import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSupportDetail } from './modules/ui/Detail';

const SupportDetailPage = (
  <SuspensePage>
    <PagesSupportDetail />
  </SuspensePage>
);

export default SupportDetailPage;
